import { rem } from 'polished'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

import { SAVE_CURATED_TRIP_BUTTON_CLASS } from 'tripPlanner/components/Buttons/SaveCuratedTripItemButton'
import { DesktopLayoutSizes } from 'tripPlanner/components/ItemCard/Common/utils'

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  padding: ${rem(20)} ${rem(16)};

  ${DesktopLayoutSizes} {
    flex-direction: row;
    align-items: center;
  }
`

const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${rem(8)};

  & > .${SAVE_CURATED_TRIP_BUTTON_CLASS} {
    align-self: end;
  }
`

const ContentWrapper = ({ children }: PropsWithChildren) => (
  <Content>
    <MainContent>{children}</MainContent>
  </Content>
)

export default ContentWrapper
